import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { BoxSetDialog } from "../components/series/BoxSetDialog";
import { StudioSeriesTimeline } from "../components/series/StudioSeriesTimeline";
import { SeriesPolishPanel } from "../components/series/SeriesPolishPanel";

export default function SeriesPage() {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const load = () => api.get("/series").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const add = async () => {
    if (!name.trim()) return;
    try { await api.post("/series", { name, description: desc }); setName(""); setDesc(""); toast.success("Series created"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (s) => { if (!window.confirm(`Delete series "${s.name}"?`)) return; try { await api.delete(`/series/${s.id}`); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div>
      <p className="eyebrow mb-2">Library</p>
      <h1 className="font-display text-4xl sm:text-5xl mb-8">Series Library</h1>
      <div className="panel p-5 flex flex-wrap gap-3 mb-8" data-testid="series-form">
        <Input placeholder="Series name" value={name} onChange={(e) => setName(e.target.value)} className="max-w-xs" data-testid="series-name-input" />
        <Input placeholder="Description (optional)" value={desc} onChange={(e) => setDesc(e.target.value)} className="flex-1 min-w-[200px]" data-testid="series-desc-input" />
        <Button onClick={add} className="bg-amber-600 hover:bg-amber-500" data-testid="series-create-button"><Plus size={14} className="mr-1" />Create series</Button>
      </div>
      <div className="grid md:grid-cols-2 gap-5">
        {list.map((s) => (
          <div key={s.id} className="panel p-6 min-w-0" data-testid={`series-card-${s.id}`}>
            <div className="flex justify-between gap-3"><h3 className="font-display text-2xl min-w-0 [overflow-wrap:anywhere]">{s.name}</h3><button onClick={() => del(s)} className="text-slate-500 hover:text-rose-300" data-testid={`series-delete-${s.id}`}><Trash2 size={15} /></button></div>
            {s.description && <p className="text-sm text-slate-400 mt-1">{s.description}</p>}
            <ol className="mt-4 space-y-1">
              {s.books.map((b) => <li key={b.id}><Link to={`/app/books/${b.id}`} className="text-sm text-slate-300 hover:text-amber-300"><span className="font-mono text-amber-500/80 mr-2">#{b.book_number ?? "?"}</span>{b.title}</Link></li>)}
              {!s.books.length && <li className="text-xs text-slate-500">No books assigned yet — set the series when creating or editing a book.</li>}
            </ol>
            <BoxSetDialog series={s} />
            {s.books.length > 0 && <SeriesPolishPanel sid={s.id} />}
            <StudioSeriesTimeline sid={s.id} />
            <p className="text-[11px] text-slate-600 mt-4 font-mono">Shared continuity canon: Continuity Manager</p>
          </div>
        ))}
      </div>
    </div>
  );
}
